import {
  ConnectedContentHttpClient,
  ProjectHttpClient,
} from '../../common/services/httpClient';
import { filterNarrativesForContent } from './narrativesUtilities';

export const getNarratives = async (projectId) => {
  const response = await ProjectHttpClient.get(
    `projects/${projectId}/narratives`
  );
  const projectNarratives = {};
  Object.keys(response.data).forEach((key) => {
    projectNarratives[key] = response.data[key].items;
  });
  return projectNarratives;
};

export const getNarrativesForContent = async (projectId, contentId) => {
  const projectNarratives = await getNarratives(projectId);
  return filterNarrativesForContent(projectNarratives, contentId);
};

export const getNarrativesCount = async (projectId) => {
  try {
    const { data = {} } = await ConnectedContentHttpClient.get(
      `projects/${projectId}/count`
    );

    return data;
  } catch (err) {
    return {};
  }
};

export const getNarrativesForKfas = async (projectId) => {
  const response = await ProjectHttpClient.get(
    `projects/${projectId}/narratives/kfa`
  );
  return response.data;
};
